import { render, staticRenderFns } from "./TransactionCategoryListDialog.vue?vue&type=template&id=83bb3d42&scoped=true"
import script from "./TransactionCategoryListDialog.vue?vue&type=script&lang=js"
export * from "./TransactionCategoryListDialog.vue?vue&type=script&lang=js"
import style0 from "./TransactionCategoryListDialog.vue?vue&type=style&index=0&id=83bb3d42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bb3d42",
  null
  
)

export default component.exports